import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, RoughEase, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p14 } from "../../../layouts/ch6_p14/ch6_p14";

export class Chapter6Page14 extends AbstractStoryState implements ReturnType<typeof ch6_p14> {

    readonly bg = this.addChild(new SceneSprite());
    readonly ringbg = this.addChild(new SceneSprite());
    readonly ringLettersContainer = this.addChild(new PIXI.Container());
    readonly ringLetters = list(()=>this.ringLettersContainer.addChild(SceneSprite.withPrefix("ch6_p14/")));

    readonly horse = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly holly = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly tyler = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly rain = [this.addChild(SceneSprite.withPrefix("ch6_p14/")), this.addChild(SceneSprite.withPrefix("ch6_p14/"))];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p14/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p14/"));

    dontScaleUp = true;
    protected lettersTimeline?: TimelineMax;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p14.call(this);

        this.horse[1].visible = false;
        this.holly[1].visible = false;
        this.tyler[1].visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        this.lettersTimeline = new TimelineMax();
		this.lettersTimeline
			.to(this.ringLetters, 1, {pixi: {
				scale: this.ringLetters[0].scale.x * 1.1,
			}, ease: new RoughEase({
				taper: 'none',
				points: 200,
				strength: 2,
				randomize: false,
			})});
		this.lettersTimeline.repeat(-1).repeatDelay(1);
    }

    public destroy() {
        super.destroy();
        this.lettersTimeline?.kill();
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        new TimelineLite()
            .call(()=>{
                this.horse[0].FadeOut();
                this.holly[0].FadeOut();
                this.tyler[0].FadeOut();

                this.horse[1].FadeIn();
                this.holly[1].FadeIn();
                this.tyler[1].FadeIn();
            })
            .call(()=>{
                super.onAnimateInComplete();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                this.gotoNextState({transition: "left"});
            }, undefined, undefined, "+=1.5")
            .delay(3);
    }

}